export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates to the Stakewithus validator to help secure the network and receive a share of incentivized rewards earned. Rewards are earned by staking tokens and are paid out at the start of every epoch.`,
  },
  {
    question: `What is the inflation?`,
    answer: `Skale has an inflationary rewards policy used to incentivise SKL holders to stake. Inflation is set at 9.3% for the first year and estimate reward rate is between 9.9% to 29.71% based on participation and staking duration.`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is a minimum stake lockup period of one entire epoch. Users will not earn rewards and will be susceptible to slashing during this period.`,
  },
  {
    question: `How to restake?`,
    answer: `Users may manually withdraw rewards and restake to compound their returns.`,
  },
  {
    question: `Is there a fee?`,
    answer: `There is a delegation commission fee paid to Stakewithus for staking.`,
  },
  {
    question: `What are the risks?`,
    answer: `Staking risks do apply including slashing involved for downtime and double signing.`,
  },
];
